import { render } from "./ClassStats.vue?vue&type=template&id=db04843c"
import script from "./ClassStats.vue?vue&type=script&lang=js"
export * from "./ClassStats.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__